/* eslint-disable jsx-a11y/anchor-is-valid */
import { Badge, Space, Tabs } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';

const { TabPane } = Tabs;

type TabMenuProps = {
  draftOrderCount: number;
  pathName: string;
  orgKey: string;
  storeKey: string;
};

const TabMenu: FC<TabMenuProps> = ({
  draftOrderCount,
  pathName,
  orgKey,
  storeKey,
}) => {
  const router = useRouter();

  const handleTabChange = (selectedTab: string) => {
    void router.push(
      `/${orgKey}/purchase-orders/${selectedTab}?store=${storeKey}`
    );
  };

  return (
    <Tabs
      defaultActiveKey={pathName.includes('drafts') ? 'drafts' : 'placed'}
      onChange={handleTabChange}
      className="h-full"
    >
      <TabPane
        tab={
          <Space>
            Draft Orders{' '}
            <Badge
              count={draftOrderCount}
              style={{ backgroundColor: '#ffcb62' }}
            />
          </Space>
        }
        key="drafts"
      >
        <h4>
          Want to create a new order?{' '}
          <Link href={`/${orgKey}/reorder-assistant?store=${storeKey}`}>
            Reorder Assistant
          </Link>{' '}
          can help.
        </h4>
      </TabPane>
      <TabPane tab="Placed Orders" key="placed">
        View/download all your previous orders
      </TabPane>
    </Tabs>
  );
};

export default TabMenu;
